<template>
  <div class="row">
    <div class="col s12 m6">
      <h1>iRecharge</h1>
      <p>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet laudantium
        animi nostrum deleniti ullam illo labore error ex beatae laboriosam?
        Laudantium eius quae nostrum omnis velit reiciendis libero aliquid
        mollitia.
      </p>
    </div>
    <div class="col s12 m6">
      <h1>iRecharge</h1>
      <p>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet laudantium
        animi nostrum deleniti ullam illo labore error ex beatae laboriosam?
        Laudantium eius quae nostrum omnis velit reiciendis libero aliquid
        mollitia.
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'More',
  components: {},
  mounted() {},
  data() {
    return {
      show: true
    }
  },
  methods: {}
}
</script>
<style>
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
</style>
